export enum SellNowFormStep {
    InfoProduct = 'infoProduct',
    Images = 'images',
    Additional = 'additional'
}

export enum SellNowTransactionStatus {
    Active = 'active',
    Sold = 'sold',
    Canceled = 'canceled'
}

export enum SellProductStatus {
    UserInfoProduct = 'infoProduct', // Ciornă info
    UserImages = 'images', // Ciornă poze
    AdminApproval = 'adminApproval', // Creat
    CanceledByUser = 'canceledByUser', // Ciornă anulată
    Refused = 'refused', // Refuzat
    CanceledByAdmin = 'canceledByAdmin', // Anulat
    AcceptedByAdmin = 'acceptedByAdmin', // Prospect
    ContractDetails = 'contractDetails', // Acceptat
    ContractSigning = 'contractSigning', // Contract semnat
    Delivery = 'delivery', // Tranzit
    QualityCheck = 'qualityCheck', // Autentificare
    Renegotiation = 'renegotiation', // Renegociere
    ReadyForReturn = 'readyForReturn', // Retur confirmat
    Rejected = 'rejected', // Respins / Restituit
    QualityCheckAccepted = 'qualityCheckAccepted', // QA acceptat
    Live = 'live', // Online
    Payment = 'payment', // Planificare la plată
    Returned = 'returned', // Returnat
    Payed = 'payed' // Achitat
}

export enum ActiveGroupFilter {
    PreContract = 'preContract',
    Transaction = 'transaction',
    Check = 'check',
    Processing = 'processing'
}
